/* eslint-disable import/prefer-default-export */
import { createSelector } from '@reduxjs/toolkit';

export const selectSidebarExpandedState = createSelector(
  [(state) => state.layout],
  (layout) => layout.sidebarExpanded,
);
